"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCartTotal = void 0;
const constant_1 = require("../constant");
const navbar_1 = require("../context/navbar");
const helpers_1 = require("../helpers");
const types_1 = require("../types");
const useFreeProducts_1 = require("./useFreeProducts");
const useCartTotal = ({ paymentType, isRewardApplied, }) => {
    const { cartItems, appliedCoupon, shippingTiers, userWithRewardPoints } = (0, navbar_1.useNavbar)();
    const totalRewardPointsOfUser = (userWithRewardPoints === null || userWithRewardPoints === void 0 ? void 0 : userWithRewardPoints.totalRewards) || 0;
    const codCharges = (0, navbar_1.useConfiguration)(constant_1.COD_CHARGES, 0);
    const prepaidDiscountPercent = (0, navbar_1.useConfiguration)(constant_1.PREPAID_DISCOUNT_PERCENT, 0);
    const maxPrepaidDiscount = (0, navbar_1.useConfiguration)(constant_1.MAX_PREPAID_DISCOUNT, 0);
    const debitPrepaidOrderCashbackRule = (0, navbar_1.useRuleEngine)(types_1.LoyaltyEventTrigger.DEBIT_PREPAID_ORDER);
    const debitCodOrderCashbackRule = (0, navbar_1.useRuleEngine)(types_1.LoyaltyEventTrigger.DEBIT_COD_ORDER);
    const creditPrepaidOrderCashbackRule = (0, navbar_1.useRuleEngine)(types_1.LoyaltyEventTrigger.CREDIT_PREPAID_ORDER);
    const creditCodOrderCashbackRule = (0, navbar_1.useRuleEngine)(types_1.LoyaltyEventTrigger.CREDIT_COD_ORDER);
    const allFreeProducts = (0, useFreeProducts_1.useFreeProducts)({
        showNonApplicableFreeProducts: false,
    });
    const freeProducts = allFreeProducts
        .filter((f) => f.allowed)
        .flatMap((f) => f.products);
    return (0, helpers_1.getCartTotals)(cartItems, freeProducts, appliedCoupon, shippingTiers, paymentType, {
        codCharges,
        maxPrepaidDiscount,
        prepaidDiscountPercent,
    }, debitPrepaidOrderCashbackRule, debitCodOrderCashbackRule, creditPrepaidOrderCashbackRule, creditCodOrderCashbackRule, totalRewardPointsOfUser, isRewardApplied);
};
exports.useCartTotal = useCartTotal;
